// extracted by mini-css-extract-plugin
export default {"checkbox":"DataElementRow_checkbox__ETYz5","field":"DataElementRow_field__zmPxc"};